"use client";
import { type CentralIconName } from "@/types/central-icon";
import { Icon } from "@/components/ui/icon";

export function FieldIcon({ name }: { name: CentralIconName }) {
  return (
    <Icon
      name={name}
      size={13}
      className="text-contrast/35 shrink-0"
    />
  );
}
